import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const isWithinSchedule = (item, now = new Date()) => {
  if (!item) return false;

  const { scheduleFrom, scheduleTo } = item;

  const scheduleNow = Math.floor(now.getTime() / 1000);

  if (scheduleFrom != null && Number.isNaN(scheduleFrom)) return false;
  if (scheduleTo != null && Number.isNaN(scheduleTo)) return false;

  if (scheduleFrom != null && scheduleTo != null && scheduleFrom > scheduleTo)
    return false;

  const afterFrom = scheduleFrom == null || scheduleNow >= scheduleFrom;
  const beforeTo = scheduleTo == null || scheduleNow <= scheduleTo;
  return afterFrom && beforeTo;
};

const Announcement = ({ selected }) => {
  const theme = useTheme();
  if (!selected) return null;

  if (!isWithinSchedule(selected)) return null;

  return (
    <Box sx={{ padding: "20px 30px" }}>
      <Typography
        sx={{
          color: theme.palette.primary.main,
          fontSize: theme.typography.customFontSize[5],
          fontWeight: theme.typography.customFontWeight[1],
        }}
      >
        {selected.title}
      </Typography>

      <Divider sx={{ margin: "20px 0" }} />

      <Box sx={{ padding: "10px 0 60px 0" }}>
        <Box
          sx={{
            color: theme.palette.primary.greyPrimary,
            fontSize: theme.typography.customFontSize[2],
          }}
          dangerouslySetInnerHTML={{ __html: selected.content }}
        />
      </Box>
    </Box>
  );
};

export default Announcement;
